module.exports = __webpack_public_path__ + "static/media/channel-mobile.c422111f.svg";